import React from 'react';
import SurveyPage from '../components/SurveyPage';
import SurveyTitleArea from '../components/SurveyTitleArea';
import SurveySection from '../components/SurveySection';
import SurveyElement from '../components/SurveyElement';
import SurveyContentContainer from '../components/SurveyContentContainer';
import SurveyGridHeader from '../components/GridComponents/SurveyGridHeader';
import SurveyGridBody from '../components/GridComponents/SurveyGridBody';
import SurveyGridRow from '../components/GridComponents/SurveyGridRow';
import {
    CommonResponses, ElementType,
    NumberFormat,
    SelectCombos, SelectCombosPABS,
    PabsMoreInfoPanels,
} from '../Enums/constants';
import SurveyConditionalSegment from '../components/SurveyConditionalSegment';


export const PabsCommunicationTab = () => {
    return (
        <SurveyPage>
            <SurveyTitleArea />
            <SurveyContentContainer>
                <SurveySection
                    id="1"
                    labelText="Calls - Volumes"
                    helpText={PabsMoreInfoPanels.CallsVolumes}
                >
                    <SurveyElement
                        questionNumber="41"
                        labelText="What were your volumes of:"
                    />
                    <SurveyElement
                        questionNumber="41.a"
                        name="VolIncoming"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="#"
                        labelText="Incoming calls that reached and were responded to by a knowledgeable service representative?"
                        note="i.e., exclude messages, etc."
                        subQuestion
                        allowUnknown
                    />
                    <SurveyElement
                        questionNumber="41.b"
                        name="VolOutgoing"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="#"
                        labelText="Outgoing calls from service representatives responding to messages (voice mall, receptionist, etc.) or following-up previous calls?"
                        subQuestion
                        allowUnknown
                        allowNA
                    />
                    <SurveyElement
                        questionNumber="41.c"
                        name="VolCallsSelfServe"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="#"
                        labelText="Incoming calls satisfied by self-serve options, if any?"
                        subQuestion
                        allowUnknown
                        allowNA
                    />
                    <SurveyElement
                        questionNumber="41.d"
                        name="Q_162b"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="#"
                        labelText="Email queries from members?"
                        subQuestion
                        allowUnknown
                        allowNA
                    />
                    <SurveyElement
                        questionNumber="41.e"
                        name="VolSecureMessages"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="#"
                        labelText="Member queries via your secure messaging portal?"
                        subQuestion
                        allowUnknown
                        allowNA
                    />
                    <SurveyElement
                        questionNumber="41.f"
                        name="VolLiveChat"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="#"
                        labelText="Member queries via live chat?"
                        subQuestion
                        allowUnknown
                        allowNA
                    />
                    <SurveyElement
                        questionNumber="41.g"
                        name="Written1"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="#"
                        labelText="Incoming mail?"
                        subQuestion
                        allowUnknown
                    />
                    <SurveyElement
                        questionNumber="41.h"
                        name="WrittenOutgoing"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="#"
                        labelText="Outgoing mail?"
                        subQuestion
                        allowUnknown
                    />
                </SurveySection>

                <SurveySection
                    id="2"
                    labelText="Calls - Before Reaching a Service Rep"
                >
                    <SurveyElement
                        questionNumber="42"
                        labelText="What number of member phone calls did not connect to a person during business hours because:"
                    />
                    <SurveyElement
                        questionNumber="42.a"
                        name="VolBusy"
                        labelText="Busy signal, never enters the system?"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="#, unknown or n/a"
                        subQuestion
                        allowUnknown
                        allowNA
                    />
                    <SurveyElement
                        questionNumber="42.b"
                        name="VolLaterBH"
                        labelText="Caller gets pre-recorded 'call another time' message during business hours?"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="#, unknown or n/a"
                        subQuestion
                        allowUnknown
                        allowNA
                    />
                    <SurveyElement
                        questionNumber="42.c"
                        name="VolHangup_Menu"
                        labelText="Abandoned calls in a menu?"
                        note="i.e. caller hangs-up before reaching the end of a self-serve menu branch that can answer his/her question or before reaching a queue."
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="#, unknown or n/a"
                        subQuestion
                        allowUnknown
                        allowNA
                    />
                    <SurveyElement
                        questionNumber="42.d"
                        name="VolHangup_Queue"
                        labelText="Abandoned calls in a queue or on hold?"
                        note="i.e. caller hangs-up"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="#, unknown or n/a"
                        subQuestion
                        allowUnknown
                        allowNA
                    />
                    <SurveyElement
                        questionNumber="42.e"
                        name="VolBusyAuto"
                        labelText="Busy signal after navigating an automated attendant menu, or after being transferred by a receptionist?"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="#, unknown or n/a"
                        subQuestion
                        allowUnknown
                        allowNA
                    />
                    <SurveyElement
                        questionNumber="42.f"
                        name="VolUnanswBH"
                        labelText="Call rings unanswered during business hours?"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="#, unknown or n/a"
                        subQuestion
                        allowUnknown
                        allowNA
                    />
                    <SurveyElement
                        questionNumber="43"
                        name="MenuYN"
                        labelText="Do you have a menu system that callers negotiate before speaking to someone?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                    />
                    <SurveyElement
                        questionNumber="43.a"
                        name="Autoa"
                        labelText="What is the average number of menu layers that must be navigated before a caller can speak to a live person?"
                        note="i.e. caller hangs-up before reaching the end of a self-serve menu branch that can answer his/her question or before reaching a queue."
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="#"
                        showIf={{
                            MenuYN: { not: CommonResponses.NO }
                        }}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="43.b"
                        name="Autoc"
                        labelText="What is the average time in seconds that it would take a caller to negotiate the menu and listen to menu options before the caller is forwarded to a live person (or queue for a live person)?"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="# seconds"
                        showIf={{
                            MenuYN: { not: CommonResponses.NO }
                        }}
                        subQuestion
                        allowUnknown
                    />
                    <SurveyElement
                        questionNumber="43.c"
                        name="MenuByPass"
                        labelText="Is the menu system by-passed if a service representative is available?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        showIf={{
                            MenuYN: { not: CommonResponses.NO }
                        }}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="43.c.c1"
                        name="MenuByPassPct"
                        labelText="If yes, for what percent of calls by-pass the menu system and go directly to a service representative?"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.PERCENTAGE}
                        placeholder="%"
                        showIf={{
                            MenuYN: { not: CommonResponses.NO },
                            MenuByPass: { not: CommonResponses.NO }
                        }}
                        doubleSubQuestion
                    />
                    <SurveyElement
                        questionNumber="44"
                        name="ReceptionistFirstContact"
                        labelText="Is a receptionist the first point of human contact when a member calls?"
                        note="A receptionist handles only basic requests like transferring calls, and is not a service representative."
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                    />
                    <SurveyElement
                        questionNumber="45"
                        name="QueueServiceRep"
                        labelText="Do you have a queue for service representatives?"
                        note="The entry to the queue could be a recorded message, a menu system or a receptionist."
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                    />
                    <SurveyElement
                        questionNumber="45.a"
                        name="WaitQueueServiceRep"
                        labelText="What is the average wait time in seconds in queue for a service representative?"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="# seconds or unknown"
                        showIf={{
                            QueueServiceRep: { not: CommonResponses.NO }
                        }}
                        allowUnknown
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="46"
                        name="WaitTimeNotifyyn"
                        labelText="Does your system notify the caller of the expected wait time, or their place in the queue, for reaching a knowledgeable service representative if the expected wait exceeds a certain threshold?"
                        note="A receptionist handles only basic requests like transferring calls, and is not a service representative."
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                    />
                    <SurveyElement
                        questionNumber="47"
                        name="CallbackFeature"
                        labelText="Do you have a callback feature on your phone system?"
                        note="i.e., the caller's telephone number is placed in a queue for callback when their turn comes up."
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                    />
                    <SurveyElement
                        questionNumber="47.a"
                        name="CallbackOnline"
                        labelText="Can a member request a callback via the website?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        showIf={{
                            CallbackFeature: { not: CommonResponses.NO }
                        }}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="47.b"
                        name="CallbackFeatureVol"
                        labelText="What was the total volume of callbacks?"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="# seconds"
                        showIf={{
                            CallbackFeature: { not: CommonResponses.NO }
                        }}
                        subQuestion
                        allowUnknown
                    />
                    <SurveyElement
                        questionNumber="47.c"
                        name="CallbackCompletion"
                        labelText="What is the callback completion rate?"
                        note="i.e., what percent of callers that chose to be called back, were actually reached."
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.PERCENTAGE}
                        placeholder="%"
                        showIf={{
                            CallbackFeature: { not: CommonResponses.NO }
                        }}
                        subQuestion
                        allowUnknown
                    />
                </SurveySection>

                <SurveySection
                    id="3"
                    labelText="Calls - After Reaching a Service Rep"
                >
                    <SurveyElement
                        questionNumber="48"
                        labelText="What was the:"
                    />
                    <SurveyElement
                        questionNumber="48.a"
                        name="TalkTime"
                        labelText="Average talk time? (in seconds)"
                        note="Do not include: hold or queuing time prior to a member reaching a knowledgeable person, or hold time after a member has reached a knowledgeable person."
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="# seconds"
                        subQuestion
                        allowUnknown
                    />
                    <SurveyElement
                        questionNumber="48.b"
                        name="WrapupTime"
                        labelText="Average after call work time when service representative is unavailable to take another call? (in seconds)"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="# seconds or unknown"
                        subQuestion
                        allowUnknown
                    />
                    <SurveyElement
                        questionNumber="48.c"
                        name="AgentOccupancyPct"
                        labelText="Average occupancy %?"
                        note="Time spent handling calls, including after call work, as a percentage of total available time to answer calls."
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.PERCENTAGE}
                        placeholder="% occupancy or unknown"
                        subQuestion
                        allowUnknown
                    />
                    <SurveyElement
                        questionNumber="48.d"
                        name="Q_150a"
                        labelText="% of calls satisfied by the first contact?"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.PERCENTAGE}
                        placeholder="%"
                        subQuestion
                        allowUnknown
                    />
                    <SurveyElement
                        questionNumber="49"
                        labelText="When a member calls in, do your service representatives have real-time access to the following member data:"
                    />
                    <SurveyElement
                        questionNumber="49.a"
                        name="Q_155a"
                        labelText="Interactions via calls and email?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="49.b"
                        name="Q_155b"
                        labelText="Copies of recent online correspondence?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO_SOME}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="49.c"
                        name="RealTimeWorkflowDigToolsYN"
                        labelText="Use of digital tools (e.g., the pension calculator in the secure area of the website, etc.)?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="49.d"
                        name="CapabilityMemberStatement"
                        labelText="Most recent member statement?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="49.e"
                        name="Q_155i"
                        labelText="Beneficiary information?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="50"
                        name="WorkflowSystem"
                        labelText="Do your service representatives have real-time access to a workflow system that lets them know the status of open items?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                    />
                    <SurveyElement
                        questionNumber="51"
                        labelText="Do you provide the following information on a real-time basis to members over the phone?"
                        note="If you do not have real-time access to the information or if your policy is not to give the information over the phone because of security or other concerns then your answer should be 'no'."
                    />
                    <SurveyElement
                        questionNumber="51.a"
                        name="Q_156a"
                        labelText="Estimates of the member's pension at retirement?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="51.a.a1"
                        name="Q_156c"
                        labelText="Can you provide alternate annuity payment options?"
                        note="i.e., joint and 50% survivor, joint and 70% survivor, etc."
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        showIf={{
                            Q_156a: { not: CommonResponses.NO }
                        }}
                        doubleSubQuestion
                    />
                    <SurveyElement
                        questionNumber="51.a.a2"
                        name="Q_156b"
                        labelText="Is the estimate based on an interactive benefit calculator linked to the member's actual account data?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        showIf={{
                            Q_156a: { not: CommonResponses.NO }
                        }}
                        doubleSubQuestion
                    />
                    <SurveyElement
                        questionNumber="51.b"
                        name="Q_156aNew"
                        labelText="Transfer value assuming the member exited employment at the time of the call?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO_NA}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="51.c"
                        name="Q_156bNew"
                        labelText="Pensionable salary?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO_NA}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="51.d"
                        name="CrmServiceCreditGap"
                        labelText="Service credit history including gaps?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO_NA}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="51.e"
                        name="Q_157"
                        labelText="Cost to purchase service credit?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO_NA}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="52"
                        labelText="Can members calling in perform the following transactions over the phone:"
                    />
                    <SurveyElement
                        questionNumber="52.a"
                        name="SACRSChangeAddress"
                        labelText="Change address?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="52.b"
                        name="ChangeEmailOverPhone"
                        labelText="Change email address?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="52.c"
                        name="SACRSChangePaymentInstructions"
                        labelText="Change payment instructions?"
                        note="i.e., bank account"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="53"
                        labelText="Do you have the following call center support technology:"
                    />
                    <SurveyElement
                        questionNumber="53.a"
                        name="WebLiveChat"
                        labelText="Live chat?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO_NA}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="53.b"
                        name="WebChatbot"
                        labelText="Chatbot or virtual service agent?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO_NA}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="53.c"
                        name="CoBrowsing"
                        labelText="Co-browsing?"
                        note="Co-browsing enables joint navigation through the secure member area by the customer service representative and member."
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO_NA}
                        subQuestion
                    />
                </SurveySection>

                <SurveySection
                    id="4"
                    labelText="Quality and Other"
                >
                    <SurveyElement
                        questionNumber="54"
                        name="Q_158"
                        labelText="Do you review your staff's responses to member calls for coaching purposes on a regular basis?"
                        note="As opposed to intermittent or only while training new service representatives, etc."
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                    />
                    <SurveyElement
                        questionNumber="54.a"
                        name="CoachingCallsMonthlyFreq"
                        labelText="How many calls per agent per month (on average) do you monitor?"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="#"
                        showIf={{
                            Q_158: { not: CommonResponses.NO }
                        }}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="54.b"
                        name="MonitoringCalls"
                        labelText="Are you listening in on a live call or a recording?"
                        inputType={ElementType.SELECT}
                        options={SelectCombosPABS.LIVE_RECORDING_BOTH}
                        saveAsKey={true}
                        showIf={{
                            Q_158: { not: CommonResponses.NO }
                        }}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="55"
                        name="Q_146"
                        labelText="Do you have a toll free number that members can call to speak with a service representative?"
                        note="Or a number where members are only charged the cost of a local call no matter where they are located."
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                    />
                    <SurveyElement
                        questionNumber="56"
                        name="Q_152"
                        labelText="How many hours per week is your 'call center' operational?"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.DECIMAL1}
                        placeholder="hours per week"
                    />
                    <SurveyElement
                        questionNumber="57"
                        name="Q_162a"
                        labelText="What is the average time (in business days) to respond to a member query via email or the secure messaging portal?"
                        note="Do not include auto-responses or confirmation of email receipt."
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.DECIMAL1}
                        placeholder="# business days"
                    />
                </SurveySection>

                <SurveySection
                    id="5"
                    labelText="1-on-1 Counseling"
                    helpText={PabsMoreInfoPanels.OneOnOneCounseling}
                >
                    <SurveyElement
                        questionNumber="58"
                        name="DoYouDo1On1"
                        labelText="Do you provide 1-on-1 counseling?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                    />
                    <SurveyElement
                        questionNumber="59"
                        labelText="Provide the number of members counseled 1-on-1 that were:"
                        showIf={{
                            DoYouDo1On1: { not: CommonResponses.NO }
                        }}
                    />
                    <SurveyElement
                        questionNumber="59.a"
                        name="InHouse1On1"
                        labelText="Pre-scheduled and/or walk-in counseled in-house?"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="#"
                        showIf={{
                            DoYouDo1On1: { not: CommonResponses.NO }
                        }}
                        subQuestion
                        allowNA
                        allowUnknown
                    />
                    <SurveyElement
                        questionNumber="59.b"
                        name="Q_114c"
                        labelText="In the field at locations separate from the member's place of employment?"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="#"
                        showIf={{
                            DoYouDo1On1: { not: CommonResponses.NO }
                        }}
                        subQuestion
                        allowNA
                        allowUnknown
                    />
                    <SurveyElement
                        questionNumber="59.c"
                        name="Q_114d"
                        labelText="At the member's place of employment?"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="#"
                        showIf={{
                            DoYouDo1On1: { not: CommonResponses.NO }
                        }}
                        subQuestion
                        allowNA
                        allowUnknown
                    />
                    <SurveyElement
                        questionNumber="59.d"
                        name="Q_114e"
                        labelText="Via teleconference?"
                        note="These are actual sessions with counselors, and may also include pre-scheduled counseling sessions covering materials sent to the member in advance."
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="#"
                        showIf={{
                            DoYouDo1On1: { not: CommonResponses.NO }
                        }}
                        subQuestion
                        allowNA
                        allowUnknown
                    />
                    <SurveyElement
                        questionNumber="59.e"
                        name="VideoConf1on1"
                        labelText="Online, via videoconference?"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="#"
                        showIf={{
                            DoYouDo1On1: { not: CommonResponses.NO }
                        }}
                        subQuestion
                        allowNA
                        allowUnknown
                    />
                    <SurveyElement
                        name="calculatedField1"
                        labelText="Total counseled 1-on-1"
                        inputType={ElementType.CALCULATED}
                        format={NumberFormat.INTEGER}
                        formula="InHouse1On1 + Q_114c + Q_114d + Q_114e  + VideoConf1on1"
                        showIf={{
                            DoYouDo1On1: { not: CommonResponses.NO }
                        }}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="60"
                        name="WalkInTraffic"
                        labelText="Do you provide counseling for walk-in traffic?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        showIf={{
                            DoYouDo1On1: { not: CommonResponses.NO }
                        }}
                    />
                    <SurveyElement
                        questionNumber="61"
                        labelText="For in-person 1-on-1 counseling sessions:"
                        showIf={{
                            DoYouDo1On1: { not: CommonResponses.NO }
                        }}
                    />
                    <SurveyElement
                        questionNumber="61.a"
                        name="InPerson_DoorYN"
                        labelText="Do almost all sessions take place in a private office with a door (versus a cubicle, etc.)?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO_NA}
                        showIf={{
                            DoYouDo1On1: { not: CommonResponses.NO }
                        }}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="61.b"
                        name="InPerson_DataYN"
                        labelText="Do you have real-time access to the member's data (i.e., salary, service credit, refund value, beneficiaries, etc.)?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO_NA}
                        showIf={{
                            DoYouDo1On1: { not: CommonResponses.NO }
                        }}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="61.c"
                        name="InPerson_EstimateYN"
                        labelText="Do you provide new written estimates on a real-time basis for anybody that wants one?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO_NA}
                        showIf={{
                            DoYouDo1On1: { not: CommonResponses.NO }
                        }}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="62"
                        name="FinancialAdvice1on1"
                        labelText="Do you provide financial advice?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        showIf={{
                            DoYouDo1On1: { not: CommonResponses.NO }
                        }}
                    />
                    <SurveyElement
                        questionNumber="62.a"
                        name="FinancialAdvice1on1MemberVol"
                        labelText="How many members received counseling by a certified financial planner?"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="#"
                        showIf={{
                            DoYouDo1On1: { not: CommonResponses.NO },
                            FinancialAdvice1on1: { not: CommonResponses.NO }
                        }}
                        subQuestion
                        allowNA
                        allowUnknown
                    />
                </SurveySection>

                <SurveySection
                    id="6"
                    labelText="Member Presentations"
                    helpText={PabsMoreInfoPanels.MemberPresentations}
                >
                    <SurveyElement
                        questionNumber="63"
                        name="Q_126"
                        labelText="Do you offer member presentations (including group counseling)?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                    />
                    <SurveyElement
                        questionNumber="64"
                        labelText="How many presentations (including group counseling sessions) for members or annuitants [exclude presentations to employers] did you do that took place:"
                        showIf={{
                            Q_126: { not: CommonResponses.NO }
                        }}
                    />
                    <SurveyElement
                        questionNumber="64.a"
                        name="PresentationsInHouse"
                        labelText="In-house?"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="#"
                        showIf={{
                            Q_126: { not: CommonResponses.NO }
                        }}
                        subQuestion
                        allowUnknown
                    />
                    <SurveyElement
                        questionNumber="64.b"
                        name="PresentationsInField"
                        labelText="In the field?"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="#"
                        showIf={{
                            Q_126: { not: CommonResponses.NO }
                        }}
                        subQuestion
                        allowUnknown
                    />
                    <SurveyElement
                        questionNumber="64.c"
                        name="PresentationsWebcast"
                        labelText="Online, via live webinar?"
                        note="i.e., a real-time, online presentation that allows two-way communication between the presenter and audience."
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="#"
                        showIf={{
                            Q_126: { not: CommonResponses.NO }
                        }}
                        subQuestion
                        allowUnknown
                    />
                    <SurveyElement
                        name="calculatedField2"
                        labelText="Total Presentations"
                        inputType={ElementType.CALCULATED}
                        format={NumberFormat.INTEGER}
                        formula="PresentationsInHouse + PresentationsInField + PresentationsWebcast"
                        showIf={{
                            Q_126: { not: CommonResponses.NO }
                        }}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="65"
                        name="PresentationAttendeesTotal"
                        labelText="What was the total number of attendees at all of the presentations per the question above?"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="#"
                        showIf={{
                            Q_126: { not: CommonResponses.NO }
                        }}
                        allowUnknown
                    />
                    <SurveyElement
                        questionNumber="66"
                        labelText="Did you do specific presentations for members, in the past fiscal year, targeted solely for:"
                        showIf={{
                            Q_126: { not: CommonResponses.NO }
                        }}
                    />
                    <SurveyElement
                        questionNumber="66.a"
                        name="NewMemberPresentations"
                        labelText="New members?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        showIf={{
                            Q_126: { not: CommonResponses.NO }
                        }}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="66.b"
                        name="MidCareerPresentations"
                        labelText="Members in mid career?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        showIf={{
                            Q_126: { not: CommonResponses.NO }
                        }}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="66.c"
                        name="RetirementPresentations"
                        labelText="Members approaching retirement or ready to retire?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        showIf={{
                            Q_126: { not: CommonResponses.NO }
                        }}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="66.d"
                        name="HealthcarePresentations"
                        labelText="Healthcare?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO_NA}
                        showIf={{
                            Q_126: { not: CommonResponses.NO }
                        }}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="66.e"
                        name="BenefitChangePresentations"
                        labelText="Changes to benefits?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        showIf={{
                            Q_126: { not: CommonResponses.NO }
                        }}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="66.f"
                        name="OtherPresentations"
                        labelText="Other? (Please describe below)"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        showIf={{
                            Q_126: { not: CommonResponses.NO }
                        }}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="66.f.f1"
                        name="OtherPresentationsDescr"
                        labelText=""
                        inputType={ElementType.TEXTAREA}
                        showIf={{
                            Q_126: { not: CommonResponses.NO },
                            OtherPresentations: { not: CommonResponses.NO }
                        }}
                        doubleSubQuestion
                    />
                </SurveySection>

                <SurveySection
                    id="7"
                    labelText="Website"
                    helpText={PabsMoreInfoPanels.Website}
                >
                    <SurveyElement
                        questionNumber="67"
                        labelText="Does your website have a secure member area where:"
                    />
                    <SurveyElement
                        questionNumber="67.a"
                        name="WebSecureAccessActive"
                        labelText="Active members can access their own data?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="67.b"
                        name="WebSecureAccessInactive"
                        labelText="Inactive members can access their own data?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="67.c"
                        name="WebSecureAccessAnnuitant"
                        labelText="Annuitants can access their own data?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="67.d"
                        name="WebGreetByName"
                        labelText="Is the member&rsquo;s name prominently displayed on the home page in their secure member area?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO_NA}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="68"
                        labelText="Is the secure member area customized to only show options relevant to each member group?"
                        note="e.g., active members see different options than annuitants."
                    />
                    <SurveyElement
                        questionNumber="68.a"
                        name="WebPersonalizedAccessActive"
                        labelText="Active members?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO_NA}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="68.b"
                        name="WebPersonalizedAccessInactive"
                        labelText="Inactive members?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO_NA}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="68.c"
                        name="WebPersonalizedAccessAnnuitant"
                        labelText="Annuitants?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO_NA}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="69"
                        name="WebUniqueVisitsToSecureArea"
                        labelText="How many unique members accessed the secure member area in the year?"
                        note="Count a member only once even if he visited multiple times."
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="#"
                        allowNA
                        allowUnknown
                    />
                    <SurveyElement
                        labelText="If available, provide the breakdown between:"
                    />
                    <SurveyElement
                        questionNumber="69.a"
                        name="WebTotalVisitsToSecureAreaActive"
                        labelText="Active members"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="# or unknown"
                        subQuestion
                        allowNA
                        allowUnknown
                    />
                    <SurveyElement
                        questionNumber="69.b"
                        name="WebTotalVisitsToSecureAreaInactive"
                        labelText="Inactive members"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="# or unknown"
                        subQuestion
                        allowNA
                        allowUnknown
                    />
                    <SurveyElement
                        questionNumber="69.c"
                        name="WebTotalVisitsToSecureAreaAnnuitant"
                        labelText="Annuitants"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="# or unknown"
                        subQuestion
                        allowNA
                        allowUnknown
                    />
                    <SurveyElement
                        questionNumber="70"
                        name="WebTotalVisitsToSecureArea"
                        labelText="Provide the total number of visits to the secure area of the website:"
                        note="i.e., if one member logs in 3 times then the answer is 3."
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="#"
                        allowNA
                        allowUnknown
                    />
                    <SurveyElement
                        questionNumber="71"
                        labelText="Which of the following authentication methods are used to access your secure area website?"
                    />
                    <SurveyElement labelText="" inputType={ElementType.LABEL} />
                    <SurveyElement
                        labelText="Primary authentication (required for all users):"
                    />
                    <SurveyElement
                        questionNumber="71.a"
                        name="WebAuthPrimaryUsernamePassword"
                        labelText="Username and password (single factor authentication)"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="71.b"
                        name="WebAuthPrimaryPasskeyBiometric"
                        labelText="Passkey/biometric authentication(e.g. fingerprint, face recognition)"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        subQuestion
                    />
                    <SurveyElement labelText="" inputType={ElementType.LABEL} />
                    <SurveyElement
                        labelText="Additional authentication factors (multi-factor-authentication)"
                    />
                    <SurveyElement
                        questionNumber="71.c"
                        name="WebAuthMfaAuthenticator"
                        labelText="Authenticator app (e.g. time based one-time password)"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="71.d"
                        name="WebAuthMfaOneTimeCodeEmail"
                        labelText="One-time code sent via email"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="71.e"
                        name="WebAuthMfaOneTimeCodeSmsVoice"
                        labelText="One-time code sent via SMS or voice call"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="71.f"
                        name="WebAuthMfaKnowledgeBased"
                        labelText="Knowledge-based questions"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="72"
                        labelText="Do you have pension estimate calculator:"
                    />
                    <SurveyElement inputType="grid" styleName={"dataTable communicationTable"}>
                        <SurveyGridHeader>
                            <SurveyElement
                                inputType={ElementType.LABEL}
                            />
                            <SurveyElement
                                labelText="Is it available?"
                                inputType={ElementType.LABEL}
                            />
                            <SurveyElement
                                labelText="If yes, volume?"
                                inputType={ElementType.LABEL}
                            />
                        </SurveyGridHeader>
                        <SurveyGridBody>
                            <SurveyGridRow>
                                <SurveyElement
                                    questionNumber="72.a"
                                    labelText="In the non-secure area?"
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    name="WebCalculatorNonSecure"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO_NA}
                                />
                                <SurveyElement
                                    name="WebCalculatorNonSecureVol"
                                    pageName="communication"
                                    inputType={ElementType.NUMBER}
                                    format={NumberFormat.INTEGER}
                                    placeholder="# or unknown"
                                    showIf={{
                                        WebCalculatorNonSecure: ["", "null", CommonResponses.YES]
                                    }}
                                    allowNA
                                    allowUnknown
                                />
                            </SurveyGridRow>
                            <SurveyGridRow>
                                <SurveyElement
                                    questionNumber="72.b"
                                    labelText="In the secure area, linked to member's salary and service data?"
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    name="WebCalculatorLinked"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO_NA}
                                />
                                <SurveyElement
                                    name="WebCalculatorLinkedVol"
                                    pageName="communication"
                                    inputType={ElementType.NUMBER}
                                    format={NumberFormat.INTEGER}
                                    placeholder="# or unknown"
                                    showIf={{
                                        WebCalculatorLinked: ["", "null", CommonResponses.YES]
                                    }}
                                    allowNA
                                    allowUnknown
                                />
                            </SurveyGridRow>
                            <SurveyGridRow
                                showIf={{
                                    WebCalculatorLinked: ["", "null", CommonResponses.YES]
                                }}
                            >
                                <SurveyElement
                                    labelText="Can the member:"
                                    inputType={ElementType.LABEL}
                                />
                            </SurveyGridRow>
                            <SurveyGridRow
                                showIf={{
                                    WebCalculatorLinked: ["", "null", CommonResponses.YES]
                                }}
                            >
                                <SurveyElement
                                    questionNumber="72.b.b1"
                                    labelText="Model different retirement start dates?"
                                    inputType={ElementType.LABEL}
                                    subQuestion
                                />
                                <SurveyElement
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    name="WebCalculatorStartDates"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO}
                                />
                            </SurveyGridRow>
                            <SurveyGridRow
                                showIf={{
                                    WebCalculatorLinked: ["", "null", CommonResponses.YES]
                                }}
                            >
                                <SurveyElement
                                    questionNumber="72.b.b2"
                                    labelText="Model salary changes?"
                                    inputType={ElementType.LABEL}
                                    subQuestion
                                />
                                <SurveyElement
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    name="WebCalculatorSalaryChanges"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO}
                                />
                            </SurveyGridRow>
                            <SurveyGridRow
                                showIf={{
                                    WebCalculatorLinked: ["", "null", CommonResponses.YES]
                                }}
                            >
                                <SurveyElement
                                    questionNumber="72.b.b3"
                                    labelText="Model different working percentages?"
                                    note="e.g., part-time or early termination"
                                    inputType={ElementType.LABEL}
                                    subQuestion
                                />
                                <SurveyElement
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    name="WebCalculatorWorkingPercentage"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO}
                                />
                            </SurveyGridRow>
                            <SurveyGridRow
                                showIf={{
                                    WebCalculatorLinked: ["", "null", CommonResponses.YES]
                                }}
                            >
                                <SurveyElement
                                    questionNumber="72.b.b4"
                                    labelText="Model alternative payment options?"
                                    inputType={ElementType.LABEL}
                                    subQuestion
                                />
                                <SurveyElement
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    name="WebCalculatorPaymentOptions"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO}
                                />
                            </SurveyGridRow>
                            <SurveyGridRow
                                showIf={{
                                    WebCalculatorLinked: ["", "null", CommonResponses.YES]
                                }}
                            >
                                <SurveyElement
                                    questionNumber="72.b.b5"
                                    labelText="Do you have a pension estimate calculator that provides estimates of:"
                                    inputType={ElementType.LABEL}
                                    subQuestion
                                />
                                <SurveyElement
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    inputType={ElementType.LABEL}
                                />
                            </SurveyGridRow>
                            <SurveyGridRow
                                showIf={{
                                    WebCalculatorLinked: ["", "null", CommonResponses.YES]
                                }}
                            >
                                <SurveyElement
                                    questionNumber="72.b.b5.b5i"
                                    labelText="Gross and net retirement income?"
                                    inputType={ElementType.LABEL}
                                    doubleSubQuestion
                                />
                                <SurveyElement
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    name="WebCalculatorGrossNet"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombosPABS.GROSS_NET_BOTH_NEITHER_NA}
                                    saveAsKey={true}
                                />
                            </SurveyGridRow>
                            <SurveyGridRow
                                showIf={{
                                    WebCalculatorLinked: ["", "null", CommonResponses.YES]
                                }}
                            >
                                <SurveyElement
                                    questionNumber="72.b.b5.b5ii"
                                    labelText="Monthly and annual retirement income?"
                                    inputType={ElementType.LABEL}
                                    doubleSubQuestion
                                />
                                <SurveyElement
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    name="WebCalculatorMonthlyAnnual"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombosPABS.MONTHLY_ANNUAL_BOTH_NEITHER_NA}
                                    saveAsKey={true}
                                />
                            </SurveyGridRow>
                            <SurveyGridRow
                                showIf={{
                                    WebCalculatorLinked: ["", "null", CommonResponses.YES]
                                }}
                            >
                                <SurveyElement
                                    questionNumber="72.b.b5.b5iii"
                                    labelText="Are various estimates run consolidated in a one-page summary for comparative purposes?"
                                    inputType={ElementType.LABEL}
                                    doubleSubQuestion
                                />
                                <SurveyElement
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    name="WebCalculatorOnePageSummary"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO_NA}
                                />
                            </SurveyGridRow>
                        </SurveyGridBody>
                    </SurveyElement>

                    <SurveyElement
                        questionNumber="73"
                        labelText="Do you have a:"
                    />
                    <SurveyElement inputType="grid" styleName={"dataTable communicationTable"}>
                        <SurveyGridHeader>
                            <SurveyElement
                                inputType={ElementType.LABEL}
                            />
                            <SurveyElement
                                inputType={ElementType.LABEL}
                            />
                            <SurveyElement
                                inputType={ElementType.LABEL}
                            />
                        </SurveyGridHeader>
                        <SurveyGridBody>
                            <SurveyGridRow>
                                <SurveyElement
                                    questionNumber="73.a"
                                    labelText="Prior service credit purchase calculator?"
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    name="WebServiceCreditPurchaseCalculator"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO_NA}
                                />
                                <SurveyElement
                                    inputType={ElementType.LABEL}
                                />
                            </SurveyGridRow>
                            <SurveyGridRow
                                showIf={{
                                    WebServiceCreditPurchaseCalculator: ["", "null", CommonResponses.YES]
                                }}
                            >
                                <SurveyElement
                                    questionNumber="73.a.a1"
                                    labelText="Is the purchase estimate final?"
                                    note="i.e., it won&rsquo;t change if the member chooses to purchase within a set time period?"
                                    inputType={ElementType.LABEL}
                                    subQuestion
                                />
                                <SurveyElement
                                    name="WebServiceCreditPurchaseCalculatorFinal"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO_NA}
                                />
                                <SurveyElement
                                    inputType={ElementType.LABEL}
                                />
                            </SurveyGridRow>
                            <SurveyGridRow>
                                <SurveyElement
                                    questionNumber="73.b"
                                    labelText="In-service credit purchase calculator?"
                                    note="e.g., maternity, parental, sabbatical, educational, illness leave."
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    name="WebLeavePurchaseCalculator"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO_NA}
                                />
                                <SurveyElement
                                    inputType={ElementType.LABEL}
                                />
                            </SurveyGridRow>
                            <SurveyGridRow
                                showIf={{
                                    WebLeavePurchaseCalculator: ["", "null", CommonResponses.YES]
                                }}
                            >
                                <SurveyElement
                                    questionNumber="73.b.b1"
                                    labelText="Is the purchase estimate final?"
                                    note="i.e., it won&rsquo;t change if the member chooses to purchase within a set time period?"
                                    inputType={ElementType.LABEL}
                                    subQuestion
                                />
                                <SurveyElement
                                    name="WebLeavePurchaseCalculatorFinal"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO_NA}
                                />
                                <SurveyElement
                                    inputType={ElementType.LABEL}
                                />
                            </SurveyGridRow>
                        </SurveyGridBody>
                    </SurveyElement>

                    <SurveyElement inputType="grid" styleName={"dataTable communicationTable"}>
                        <SurveyGridHeader>
                            <SurveyElement
                                questionNumber="74"
                                labelText="Indicate whether the following capabilities are available on your website:"
                                inputType={ElementType.LABEL}
                            />
                            <SurveyElement
                                labelText="Is it available?"
                                inputType={ElementType.LABEL}
                            />
                            <SurveyElement
                                inputType={ElementType.LABEL}
                            />
                        </SurveyGridHeader>
                        <SurveyGridBody>
                            <SurveyGridRow>
                                <SurveyElement
                                    labelText="View:"
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    inputType={ElementType.LABEL}
                                />
                            </SurveyGridRow>
                            <SurveyGridRow>
                                <SurveyElement
                                    questionNumber="74.a"
                                    labelText="The most recent member statement?"
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    name="WebAdobeMemberStatement"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO_NA}
                                />
                                <SurveyElement
                                    inputType={ElementType.LABEL}
                                />
                            </SurveyGridRow>
                            <SurveyGridRow>
                                <SurveyElement
                                    questionNumber="74.b"
                                    labelText="Pensionable earnings and/or service without downloading?"
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    name="WebSalaryServiceHTML"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO_NA}
                                />
                                <SurveyElement
                                    inputType={ElementType.LABEL}
                                />
                            </SurveyGridRow>
                            <SurveyGridRow
                                showIf={{
                                    WebSalaryServiceHTML: ["", "null", CommonResponses.YES]
                                }}
                            >
                                <SurveyElement
                                    questionNumber="74.b.b1"
                                    labelText="Is salary and service data available?"
                                    inputType={ElementType.LABEL}
                                    subQuestion
                                />
                                <SurveyElement
                                    name="BothSalaryAndService"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO_NA}
                                />
                                <SurveyElement
                                    inputType={ElementType.LABEL}
                                />
                            </SurveyGridRow>
                            <SurveyGridRow
                                showIf={{
                                    WebSalaryServiceHTML: ["", "null", CommonResponses.YES]
                                }}
                            >
                                <SurveyElement
                                    questionNumber="74.b.b2"
                                    labelText="Is online data up-to-date to the most recent pay period?"
                                    inputType={ElementType.LABEL}
                                    subQuestion
                                />
                                <SurveyElement
                                    name="CurrentToRecentPayPeriod"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO_NA}
                                />
                                <SurveyElement
                                    inputType={ElementType.LABEL}
                                />
                            </SurveyGridRow>
                            <SurveyGridRow
                                showIf={{
                                    WebSalaryServiceHTML: ["", "null", CommonResponses.YES]
                                }}
                            >
                                <SurveyElement
                                    questionNumber="74.b.b3"
                                    labelText="Is a complete annual history from the beginning of employment provided?"
                                    inputType={ElementType.LABEL}
                                    subQuestion
                                />
                                <SurveyElement
                                    name="CompleteHistory"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO_NA}
                                />
                                <SurveyElement
                                    inputType={ElementType.LABEL}
                                />
                            </SurveyGridRow>
                            <SurveyGridRow>
                                <SurveyElement
                                    questionNumber="74.c"
                                    labelText="Pension payment details?"
                                    note="i.e., gross amounts, deductions"
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    name="PaymentAdviceOnline"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO_NA}
                                />
                                <SurveyElement
                                    inputType={ElementType.LABEL}
                                />
                            </SurveyGridRow>
                            <SurveyGridRow>
                                <SurveyElement
                                    questionNumber="74.d"
                                    labelText="Duplicate tax receipts?"
                                    note="i.e., 1099s in the U.S."
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    name="WebDuplicateTaxReceipt"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO_NA}
                                />
                                <SurveyElement
                                    inputType={ElementType.LABEL}
                                />
                            </SurveyGridRow>
                            <SurveyGridRow>
                                <SurveyElement
                                    questionNumber="74.e"
                                    labelText="History of recent correspondence?"
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    name="PersonalDigitalFileRecentOrMailbox"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO_NA}
                                />
                                <SurveyElement
                                    inputType={ElementType.LABEL}
                                />
                            </SurveyGridRow>
                            <SurveyGridRow>
                                <SurveyElement
                                    labelText="Transactions:"
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    labelText="Is it available?"
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    labelText="Can it be completed online without any staff assistance (excl. internal review/approval)?"
                                    inputType={ElementType.LABEL}
                                />
                            </SurveyGridRow>
                            <SurveyGridRow>
                                <SurveyElement
                                    questionNumber="74.f"
                                    labelText="Apply for retirement?"
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    name="WebApplyForRetirementClarifiedOnline"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO_NA}
                                />
                                <SurveyElement
                                    name="WebApplyForRetirementOnlineWithoutStaff"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO}
                                    showIf={{
                                        WebApplyForRetirementClarifiedOnline: [CommonResponses.BLANK, "null", CommonResponses.YES]
                                    }}
                                />
                            </SurveyGridRow>
                            <SurveyGridRow>
                                <SurveyElement
                                    questionNumber="74.g"
                                    labelText="Change beneficiary?"
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    name="WebChangeBeneficiary"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO_NA}
                                />
                                <SurveyElement
                                    name="WebChangeBeneficiaryWithoutStaff"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO}
                                    showIf={{
                                        WebChangeBeneficiary: ["", "null", CommonResponses.YES]
                                    }}
                                />
                            </SurveyGridRow>
                            <SurveyGridRow>
                                <SurveyElement
                                    questionNumber="74.h"
                                    labelText="Change banking information for direct deposit?"
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    name="WebChangeBanking"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO_NA}
                                />
                                <SurveyElement
                                    name="WebChangeBankingWithoutStaff"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO}
                                    showIf={{
                                        WebChangeBanking: ["", "null", CommonResponses.YES]
                                    }}
                                />
                            </SurveyGridRow>
                            <SurveyGridRow>
                                <SurveyElement
                                    questionNumber="74.i"
                                    labelText="Change address?"
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    name="WebChangeAddress"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO_NA}
                                />
                                <SurveyElement
                                    name="WebChangeAddressWithoutStaff"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO}
                                    showIf={{
                                        WebChangeAddress: ["", "null", CommonResponses.YES]
                                    }}
                                />
                            </SurveyGridRow>
                            <SurveyGridRow>
                                <SurveyElement
                                    questionNumber="74.j"
                                    labelText="Change email address?"
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    name="WebChangeEmail"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO_NA}
                                />
                                <SurveyElement
                                    name="WebChangeEmailWithoutStaff"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO}
                                    showIf={{
                                        WebChangeEmail: ["", "null", CommonResponses.YES]
                                    }}
                                />
                            </SurveyGridRow>
                            <SurveyGridRow>
                                <SurveyElement
                                    questionNumber="74.k"
                                    labelText="Change tax withholding amount?"
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    name="WebChangeTaxWithholding"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO_NA}
                                />
                                <SurveyElement
                                    name="WebChangeTaxWithholdingWithoutStaff"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO}
                                    showIf={{
                                        WebChangeTaxWithholding: ["", "null", CommonResponses.YES]
                                    }}
                                />
                            </SurveyGridRow>
                            <SurveyGridRow>
                                <SurveyElement
                                    questionNumber="74.l"
                                    labelText="Apply for a transfer-in?"
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    name="WebApplyTransferIn"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO_NA}
                                />
                                <SurveyElement
                                    name="WebApplyTransferInWithoutStaff"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO}
                                    showIf={{
                                        WebApplyTransferIn: ["", "null", CommonResponses.YES]
                                    }}
                                />
                            </SurveyGridRow>
                            <SurveyGridRow>
                                <SurveyElement
                                    questionNumber="74.m"
                                    labelText="Apply for a transfer-out?"
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    name="WebApplyRefund"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO_NA}
                                />
                                <SurveyElement
                                    name="WebApplyRefundWithoutStaff"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO}
                                    showIf={{
                                        WebApplyRefund: ["", "null", CommonResponses.YES]
                                    }}
                                />
                            </SurveyGridRow>
                            <SurveyGridRow>
                                <SurveyElement
                                    questionNumber="74.n"
                                    labelText="Apply for a prior service credit purchase?"
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    name="WebApplyPurchase"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO_NA}
                                />
                                <SurveyElement
                                    name="WebApplyPurchaseWithoutStaff"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO}
                                    showIf={{
                                        WebApplyPurchase: ["", "null", CommonResponses.YES]
                                    }}
                                />
                            </SurveyGridRow>
                            <SurveyGridRow>
                                <SurveyElement
                                    questionNumber="74.o"
                                    labelText="Apply for an in-service credit purchase?"
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    name="WebApplyLeavePurchase"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO_NA}
                                />
                                <SurveyElement
                                    name="WebApplyLeavePurchaseWithoutStaff"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO}
                                    showIf={{
                                        WebApplyLeavePurchase: ["", "null", CommonResponses.YES]
                                    }}
                                />
                            </SurveyGridRow>
                            <SurveyGridRow>
                                <SurveyElement
                                    questionNumber="74.p"
                                    labelText="Upload documents?"
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    name="WebUpload"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO_NA}
                                />
                                <SurveyElement
                                    inputType={ElementType.LABEL}
                                />
                            </SurveyGridRow>
                            <SurveyGridRow>
                                <SurveyElement
                                    questionNumber="74.q"
                                    labelText="Change communication preferences?"
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    name="CommunicationPreferences"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO_NA}
                                />
                                <SurveyElement
                                    inputType={ElementType.LABEL}
                                />
                            </SurveyGridRow>
                        </SurveyGridBody>
                    </SurveyElement>
                    <SurveyElement
                        questionNumber="75"
                        name="WebApplyForRetirementvolumeClarifiedOnline"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="#, n/a or unknown"
                        labelText="How many members submitted their retirement application online?"
                        allowNA
                        allowUnknown
                        showIf={{
                            WebApplyForRetirementClarifiedOnline: { not: CommonResponses.NO }
                        }}
                    />
                    <SurveyElement
                        questionNumber="75.a"
                        name="WebApplyForRetireClarifEstimateOrFinal"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.ESTIMATE_FINAL_NEITHER_NA}
                        labelText="Is the member provided with an estimate, final (gross or net) amount, or neither?"
                        subQuestion
                        showIf={{
                            WebApplyForRetirementClarifiedOnline: { not: CommonResponses.NO }
                        }}
                    />
                    <SurveyElement
                        questionNumber="75.b"
                        name="WebApplyForRetirementFollowup"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.PERCENTAGE}
                        placeholder="%"
                        labelText="What proportion of online retirement applications were completed without any manual staff assistance during the online submission and processing stage?"
                        note='"Staff assistance" refers only to actions required during the online application process that prevent the member from completing the retirement application fully online.<br/>It does not include internal reviews or approvals that occur after the application is submitted and are not visible to the member.'
                        subQuestion
                        allowNA
                        allowUnknown
                        showIf={{
                            WebApplyForRetirementClarifiedOnline: { not: CommonResponses.NO }
                        }}
                    />
                    <SurveyElement
                        questionNumber="75.c"
                        name="WebStatusRetirement"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO_NA}
                        labelText="Can members track the status of their online retirement application?"
                        subQuestion
                        showIf={{
                            WebApplyForRetirementClarifiedOnline: { not: CommonResponses.NO }
                        }}
                    />
                </SurveySection>

                <SurveySection
                    id="8"
                    labelText="Outbound communication"
                >
                    <SurveyElement
                        questionNumber="76"
                        labelText="What % of email addresses do you have in your system for the following groups:"
                        inputType={ElementType.LABEL}
                    />
                    <SurveyElement
                        questionNumber="76.a"
                        name="EmailsActivePct"
                        labelText="Active members?"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.PERCENTAGE}
                        placeholder="%"
                        allowUnknown
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="76.b"
                        name="EmailsInactivePct"
                        labelText="Vested inactive members?"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.PERCENTAGE}
                        placeholder="%"
                        allowUnknown
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="76.c"
                        name="EmailsAnnuitantsPct"
                        labelText="Annuitants?"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.PERCENTAGE}
                        placeholder="%"
                        allowUnknown
                        subQuestion
                    />

                    <SurveyElement inputType="grid" styleName={"dataTable communicationTable"}>
                        <SurveyGridHeader>
                            <SurveyElement
                                questionNumber="77"
                                labelText="Do you automatically send targeted emails or letters to members in the following circumstances:"
                                inputType={ElementType.LABEL}
                            />
                            <SurveyElement
                                labelText="Active members"
                                inputType={ElementType.LABEL}
                            />
                            <SurveyElement
                                labelText="Inactive members"
                                inputType={ElementType.LABEL}
                            />
                            <SurveyElement
                                labelText="Annuitants"
                                inputType={ElementType.LABEL}
                            />
                        </SurveyGridHeader>
                        <SurveyGridBody>
                            <SurveyGridRow>
                                <SurveyElement
                                    questionNumber="77.a"
                                    labelText="Approaching eligibility for retirement?"
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    name="PersonalizedEligibleToRetireActive"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO_NA}
                                />
                                <SurveyElement
                                    name="PersonalizedEligibleToRetireInactive"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO}
                                />
                                <SurveyElement
                                    inputType={ElementType.LABEL}
                                />
                            </SurveyGridRow>
                            <SurveyGridRow>
                                <SurveyElement
                                    questionNumber="77.b"
                                    labelText="Missing beneficiary information?"
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    name="PersonalizedMissingBeneficiaryActive"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO_NA}
                                />
                                <SurveyElement
                                    name="PersonalizedMissingBeneficiaryInactive"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO_NA}
                                />
                                <SurveyElement
                                    name="PersonalizedMissingBeneficiaryAnnuitant"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO_NA}
                                />
                            </SurveyGridRow>
                            <SurveyGridRow>
                                <SurveyElement
                                    questionNumber="77.c"
                                    labelText="Missing email address?"
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    name="PersonalizedMissingEmailAddress"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO_NA}
                                />
                                <SurveyElement
                                    name="PersonalizedMissingEmailAddressInactive"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO}
                                />
                                <SurveyElement
                                    name="PersonalizedMissingEmailAddressAnnuitant"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO}
                                />
                            </SurveyGridRow>
                            <SurveyGridRow>
                                <SurveyElement
                                    questionNumber="77.d"
                                    labelText="Missing address?"
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    name="PersonalizedMissingAddressInactive"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO}
                                />
                                <SurveyElement
                                    name="PersonalizedMissingAddressAnnuitant"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO}
                                />
                            </SurveyGridRow>
                            <SurveyGridRow>
                                <SurveyElement
                                    questionNumber="77.e"
                                    labelText="New members?"
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    name="Q_184"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO_NA}
                                />
                                <SurveyElement
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    inputType={ElementType.LABEL}
                                />
                            </SurveyGridRow>
                            <SurveyGridRow>
                                <SurveyElement
                                    questionNumber="77.f"
                                    labelText="Eligibility or likely eligibility, to purchase prior service credit?"
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    name="PersonalizedEligibleServiceCredit"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO_NA}
                                />
                                <SurveyElement
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    inputType={ElementType.LABEL}
                                />
                            </SurveyGridRow>
                            <SurveyGridRow>
                                <SurveyElement
                                    questionNumber="77.g"
                                    labelText="Members are vested for pension benefits (if not vested immediately)?"
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    name="Q_188a"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO_NA}
                                />
                                <SurveyElement
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    inputType={ElementType.LABEL}
                                />
                            </SurveyGridRow>
                            <SurveyGridRow>
                                <SurveyElement
                                    questionNumber="77.h"
                                    labelText="Eligibility to purchase in-leave service credit?"
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    name="PersonalizedEligibleLeaveServiceCredit"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO_NA}
                                />
                                <SurveyElement
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    inputType={ElementType.LABEL}
                                />
                            </SurveyGridRow>
                            <SurveyGridRow>
                                <SurveyElement
                                    questionNumber="77.i"
                                    labelText="Leaving the plan?"
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    name="PersonalizedInactive"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO}
                                />
                                <SurveyElement
                                    inputType={ElementType.LABEL}
                                />
                            </SurveyGridRow>
                            <SurveyGridRow>
                                <SurveyElement
                                    questionNumber="77.j"
                                    labelText="New retirees?"
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    name="PersonalizedRetirees"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO}
                                />
                            </SurveyGridRow>
                            <SurveyGridRow>
                                <SurveyElement
                                    questionNumber="77.k"
                                    labelText="Pension amount changes?"
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    name="PersonalizedAmountChange"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO_NA}
                                />
                            </SurveyGridRow>
                            <SurveyGridRow>
                                <SurveyElement
                                    questionNumber="77.l"
                                    labelText="Members are vested for disability benefits (if not vested immediately)?"
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    name="Q_188b"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO_NA}
                                />
                            </SurveyGridRow>
                            <SurveyGridRow>
                                <SurveyElement
                                    questionNumber="77.m"
                                    labelText="Expiration of disability benefits for inactive members"
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    name="PersonalizedDisabilityExpiry"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO_NA}
                                />
                                <SurveyElement
                                    inputType={ElementType.LABEL}
                                />
                            </SurveyGridRow>
                            <SurveyGridRow>
                                <SurveyElement
                                    questionNumber="77.n"
                                    labelText="Other milestone communication? (describe below)"
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    name="Q_188d"
                                    pageName="communication"
                                    inputType={ElementType.SELECT}
                                    options={SelectCombos.YES_NO}
                                />
                                <SurveyElement
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    inputType={ElementType.LABEL}
                                />
                            </SurveyGridRow>
                            <SurveyElement
                                name="Q_188dDesc"
                                pageName="communication"
                                inputType={ElementType.TEXTAREA}
                                showIf={{ Q_188d: { not: CommonResponses.NO } }}
                            />
                        </SurveyGridBody>
                    </SurveyElement>
                    <SurveyElement
                        questionNumber="78"
                        labelText="How many times did you send newsletter by mail or email to the following member segments in the past year:"
                        inputType={ElementType.LABEL}
                    />
                    <SurveyElement
                        questionNumber="78.a"
                        name="AumQ_176ATargetedNewsletterContributingfreq"
                        labelText="Active members?"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="# or unlimited"
                        subQuestion
                        allowNA
                    />
                    <SurveyElement
                        questionNumber="78.b"
                        name="AuTargetedNewsletterInactivefreq"
                        labelText="Inactive members?"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="# or unlimited"
                        subQuestion
                        allowNA
                    />
                    <SurveyElement
                        questionNumber="78.c"
                        name="AumQ_176BTargetedNewsletterPensionerfreq"
                        labelText="Annuitants?"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="# or unlimited"
                        subQuestion
                        allowNA
                    />
                    <SurveyElement
                        questionNumber="79"
                        labelText="Do the following member segments receive a different newsletter from the other member groups?"
                        inputType={ElementType.LABEL}
                    />
                    <SurveyElement
                        questionNumber="79.a"
                        name="UniqueNewsletterActive"
                        labelText="Active members?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO_NA}
                        subQuestion
                        allowNA
                    />
                    <SurveyElement
                        questionNumber="79.b"
                        name="UniqueNewsletterInactive"
                        labelText="Inactive members"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO_NA}
                        subQuestion
                        allowNA
                    />
                    <SurveyElement
                        questionNumber="79.c"
                        name="UniqueNewsletterAnnuitant"
                        labelText="Annuitants?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO_NA}
                        subQuestion
                        allowNA
                    />
                </SurveySection>

                <SurveySection
                    id="9"
                    labelText="Member Statements"
                >
                    <SurveyElement
                        questionNumber="80"
                        name="StatementsDistributeMethod"
                        labelText="How do you distribute your member statements?"
                        inputType={ElementType.SELECT}
                        options={SelectCombosPABS.ONLINE_MAIL_BOTH_NA}
                        saveAsKey={true}
                    />
                    <SurveyConditionalSegment
                        showIf={{
                            StatementsDistributeMethod: ["", "null", "mail", "both"]
                        }}
                    >
                        <SurveyElement
                            questionNumber="81"
                            labelText="Do you mail paper member statements to:"
                            inputType={ElementType.LABEL}
                        />
                        <SurveyElement
                            questionNumber="81.a"
                            name="StatementsAllActives"
                            labelText="Active members, either all active members or all members that have opted in to receiving mail?"
                            inputType={ElementType.SELECT}
                            options={SelectCombos.YES_NO_NA}
                            subQuestion
                        />
                        <SurveyElement
                            questionNumber="81.b"
                            name="StatementsPassiveActives"
                            labelText="Active members who have not accessed the secure member portal in the last year?"
                            inputType={ElementType.SELECT}
                            options={SelectCombos.YES_NO_NA}
                            subQuestion
                        />
                        <SurveyElement
                            questionNumber="81.c"
                            name="StatementsPassiveInactives"
                            labelText="Inactive members, either all members or all members that have opted in to receiving mail?"
                            inputType={ElementType.SELECT}
                            options={SelectCombos.YES_NO_NA}
                            subQuestion
                        />
                        <SurveyElement
                            questionNumber="82"
                            name="Q_181"
                            labelText="On average, how current is an active member's data in the mailed statements that the member receives?"
                            note="For example, if statements with data current to December 31st are mailed in a staggered mailing beginning May 1st and finishing June 30th, then the members are receiving data that is between 4 and 6 months old, or 5 months old on average."
                            inputType={ElementType.NUMBER}
                            format={NumberFormat.INTEGER}
                            placeholder="# months"
                            allowNA
                        />
                    </SurveyConditionalSegment>
                    <SurveyConditionalSegment
                        showIf={{
                            StatementsDistributeMethod: ["", "null", "online", "both"]
                        }}
                    >
                        <SurveyElement
                            questionNumber="83"
                            labelText="If member statements are available online:"
                            inputType={ElementType.LABEL}
                        />
                        <SurveyElement
                            questionNumber="83.a"
                            name="EmailStatementsYN"
                            labelText="Do you send an email notice or text message to members (that have opted out of receiving mail) annually that the member statement is available online?"
                            inputType={ElementType.SELECT}
                            options={SelectCombos.YES_NO_NA}
                            subQuestion
                        />
                        <SurveyElement
                            questionNumber="83.b"
                            name="StatementsUpdatedRealData"
                            labelText="Is the member statement updated based on real-time data?"
                            inputType={ElementType.SELECT}
                            options={SelectCombos.YES_NO_NA}
                            subQuestion
                        />
                        <SurveyElement
                            questionNumber="83.b.b1"
                            name="StatementsOnlineDataCurrent"
                            labelText="If no, how current is an active member's data, on average?"
                            inputType={ElementType.NUMBER}
                            format={NumberFormat.DECIMAL1}
                            placeholder="# months"
                            showIf={{
                                StatementsUpdatedRealData: ["", "null", CommonResponses.NO]
                            }}
                            allowNA
                            allowUnknown
                            doubleSubQuestion
                        />
                    </SurveyConditionalSegment>
                    <SurveyConditionalSegment
                        showIf={{
                            StatementsDistributeMethod: { not: "N/A" }
                        }}
                    ><SurveyElement
                            questionNumber="84"
                            labelText="Do your paper or online statements for active members include:"
                            inputType={ElementType.LABEL}
                        />
                        <SurveyElement
                            questionNumber="84.a"
                            name="Q_183a"
                            labelText="Total accumulated service credit?"
                            inputType={ElementType.SELECT}
                            options={SelectCombos.YES_NO_NA}
                            subQuestion
                        />
                        <SurveyElement
                            questionNumber="84.b"
                            name="Q_183b"
                            labelText="Pensionable earnings?"
                            inputType={ElementType.SELECT}
                            options={SelectCombos.YES_NO_NA}
                            subQuestion
                        />
                        <SurveyElement
                            questionNumber="84.c"
                            name="Q_183Bonus"
                            labelText="A historical summary of salary and service credit earned each year?"
                            inputType={ElementType.SELECT}
                            options={SelectCombos.YES_NO_NA}
                            subQuestion
                        />
                        <SurveyElement
                            questionNumber="84.d"
                            name="Q_183d"
                            labelText="An estimate of the future pension entitlement based on age scenario modeling or assuming the member continues to work until earliest possible retirement?"
                            inputType={ElementType.SELECT}
                            options={SelectCombos.YES_NO_NA}
                            subQuestion
                        />
                    </SurveyConditionalSegment>
                </SurveySection>

                <SurveySection
                    id="10"
                    labelText="Collections and Data Maintenance"
                >
                    <SurveyElement
                        questionNumber="85"
                        labelText="Number of:"
                        inputType={ElementType.LABEL}
                    />
                    <SurveyElement
                        questionNumber="85.a"
                        name="Employers"
                        labelText="Employers at the end of your fiscal year?"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="#"
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="85.b"
                        name="Q_269b"
                        labelText="Employers that joined your system during the fiscal year?"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="#"
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="85.c"
                        name="Q_269c"
                        labelText="Employers that exited your system during the fiscal year?"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="#"
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="86"
                        labelText="How many 'collection points' (i.e., employers, state agencies, departments and/or service providers etc) do you deal with for collecting:"
                        inputType={ElementType.LABEL}
                    />
                    <SurveyElement
                        questionNumber="86.a"
                        name="DataCollectionPoints"
                        labelText="Member payroll data?"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="#"
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="86.b"
                        name="MoneyCollectionPoints"
                        labelText="Money ? i.e., contributions"
                        note="Your number of 'collection points' could be less than your number of employers if, for example, some of your payroll data comes from a central agency that processes payroll data from numerous employers and then provides it to you in a consolidated, integrated format."
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="#"
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="87"
                        labelText="How many 'reconciliation points' (i.e., employers, state agencies, departments and/or service providers, etc.) do you deal with when:"
                        inputType={ElementType.LABEL}
                    />
                    <SurveyElement
                        questionNumber="87.a"
                        name="DataReconciliationPoints"
                        labelText="Validating member data?"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="#"
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="87.b"
                        name="MoneyReconcilationPoints"
                        labelText="Reconciling money issues? i.e., contributions"
                        note="For most systems, the number of 'reconciliation points' will be the same as the number of 'collection points' per question immediately above. But they could be different. For example, MOSERS has 1 primary collection point - the Office of Administration. The Office of Administration does not check to see if employers have sent the correct amount. MOSERS has to go back to the individual payroll offices at each employer to reconcile money problems and validate data."
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="#"
                        subQuestion
                    />

                    <SurveyElement inputType="grid" styleName={"dataTable communicationTable"}>
                        <SurveyGridHeader>
                            <SurveyElement
                                questionNumber="88"
                                labelText="What is the breakdown of 'collection points' providing you with payroll data between the following formats and what is the total number of active members covered by each format?"
                                inputType={ElementType.LABEL}
                            />
                            <SurveyElement
                                labelText="# of Collection Points"
                                inputType={ElementType.LABEL}
                            />
                            <SurveyElement
                                labelText="Total # of active members (000s)"
                                inputType={ElementType.LABEL}
                            />
                        </SurveyGridHeader>
                        <SurveyGridBody>
                            <SurveyGridRow>
                                <SurveyElement
                                    questionNumber="88.a"
                                    labelText="100% electronic?"
                                    note="No manual steps required unless there are errors."
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    name="ElectronicCollectionPoints"
                                    inputType={ElementType.NUMBER}
                                    format={NumberFormat.INTEGER}
                                    placeholder="#"
                                />
                                <SurveyElement
                                    name="ElectronicActives"
                                    inputType={ElementType.NUMBER}
                                    format={NumberFormat.DECIMAL1}
                                    placeholder="# (000s)"
                                />
                            </SurveyGridRow>
                            <SurveyGridRow>
                                <SurveyElement
                                    questionNumber="88.b"
                                    labelText="Mostly electronic?"
                                    note="For example, some systems receive files by internet and then must manually start a program that uploads the file."
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    name="MostlyElectronicCollectionPoints"
                                    inputType={ElementType.NUMBER}
                                    format={NumberFormat.INTEGER}
                                    placeholder="#"
                                />
                                <SurveyElement
                                    name="MostlyElectronicActives"
                                    inputType={ElementType.NUMBER}
                                    format={NumberFormat.DECIMAL1}
                                    placeholder="# (000s)"
                                />
                            </SurveyGridRow>
                            <SurveyGridRow>
                                <SurveyElement
                                    questionNumber="88.c"
                                    labelText="Computer readable?"
                                    note="i.e., via computer tape or disk"
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    name="Q_272b"
                                    inputType={ElementType.NUMBER}
                                    format={NumberFormat.INTEGER}
                                    placeholder="#"
                                />
                                <SurveyElement
                                    name="Q_272bb"
                                    inputType={ElementType.NUMBER}
                                    format={NumberFormat.DECIMAL1}
                                    placeholder="# (000s)"
                                />
                            </SurveyGridRow>
                            <SurveyGridRow>
                                <SurveyElement
                                    questionNumber="88.d"
                                    labelText="Paper?"
                                    inputType={ElementType.LABEL}
                                />
                                <SurveyElement
                                    name="Q_272c"
                                    inputType={ElementType.NUMBER}
                                    format={NumberFormat.INTEGER}
                                    placeholder="#"
                                />
                                <SurveyElement
                                    name="Q_272cc"
                                    inputType={ElementType.NUMBER}
                                    format={NumberFormat.DECIMAL1}
                                    placeholder="# (000s)"
                                />
                            </SurveyGridRow>
                        </SurveyGridBody>
                    </SurveyElement>
                    <SurveyElement
                        questionNumber="89"
                        name="Q_287"
                        labelText="Do you actively keep track of the addresses of inactive members?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        placeholder="#"
                        allowUnknown
                    />

                </SurveySection>
                <SurveySection
                    id="11"
                    labelText="Service to Employers"
                >
                    <SurveyElement
                        questionNumber="90"
                        labelText="Number of:"
                        inputType={ElementType.LABEL}
                    />
                    <SurveyElement
                        questionNumber="90.a"
                        name="EmployerCalls"
                        labelText="Incoming calls from employers?"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="#"
                        allowUnknown
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="90.b"
                        name="EmployerEmails"
                        labelText="Email queries from employers?"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="#"
                        allowUnknown
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="90.c"
                        name="EmployerConference"
                        labelText="Conferences for employers (conferences must span more than half a day and typically involve multiple presentations)?"
                        note="For example, some administrators with multiple employers host an annual conference to update the employers on trends, regulation, legislation, and new services that might affect their pension plan."
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="#"
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="90.d"
                        name="EmployerPresentations"
                        labelText="Presentations given to employers such as orientation workshops or seminars on benefit changes, etc. (do not include presentations given at conferences)?"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="#"
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="90.e"
                        name="NumberOfAudits"
                        labelText="On-site reviews (or audits or inspections) of your employers?"
                        note="For example, several systems perform reviews of their employers that have problems providing data and or contributions on a timely basis to ensure that they are correctly fulfilling their obligations to their members."
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="#"
                        allowUnknown
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="90.f"
                        name="OtherEmployerSiteVisits"
                        labelText="Other site visits to employers (exclude 'd' and 'e' above)?"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="#"
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="91"
                        name="EmployerSecureWebsiteRegisteredVol"
                        labelText="At the end of the most recent fiscal year, how many of your current employers were registered to use your secure employer portal?"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="# or n/a"
                        allowUnknown
                        allowNA
                    />
                    <SurveyElement
                        questionNumber="92"
                        name="EmployerSecureWebsiteUniqueLoginsVol"
                        labelText="In the last year, how many unique employers logged in to your secure employer portal?"
                        note="Count each employer only once, even if they logged in multiple times."
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="# or n/a"
                        allowUnknown
                        allowNA
                    />
                    <SurveyElement
                        questionNumber="93"
                        name="EmployerSecureWebsiteTotalLogInsVol"
                        labelText="In the last year, how many total logins were made to your secure employer portal?"
                        note="Count each login, even if made by the same employer"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder="# or n/a"
                        allowUnknown
                        allowNA
                    />
                </SurveySection>
            </SurveyContentContainer>
        </SurveyPage>
    );
}